import {toast} from 'react-toastify'
import {useEffect, useRef, useState} from 'react'

import {getTrackingProps} from '@sdox/utils/dom'
import {IconCheckmark, IconCopy} from '@sdox/icons'

import {Button} from '../'

import type {ButtonProps} from '../'

export interface CopyButtonProps extends Omit<ButtonProps, 'leading' | 'trailing'> {
  copyContent: string
  onTimeoutEnd?: () => void
}

const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch (e) {
    console.error(e)
    return false
  }
}

export const CopyButton = (props: CopyButtonProps) => {
  const {
    copyContent,
    onClick: onClickProp,
    onTimeoutEnd,
    mboAttrs,
    ...restProps
  } = props

  const timeout = useRef<ReturnType<typeof setTimeout>>()
  const [isCopied, setIsCopied] = useState(false)

  useEffect(() => {
    return () => {
      clearTimeout(timeout.current)
    }
  }, [])

  const onClick: ButtonProps['onClick'] = async (...args) => {
    if (await copyToClipboard(copyContent)) {
      toast.success('Text kopiert.')
      setIsCopied(true)
      timeout.current = setTimeout(() => {
        setIsCopied(false)
        onTimeoutEnd?.()
      }, 4000)
    }
    onClickProp?.(...args)
  }

  return (
    <Button
      onClick={onClick}
      {...(mboAttrs ? getTrackingProps(mboAttrs) : null)}
      {...restProps}
      trailing={isCopied ? <IconCheckmark /> : <IconCopy />}
      disabled={isCopied}
    />
  )
}
